// extracted by mini-css-extract-plugin
module.exports = {"SAdmissions":"ChartItemAdmissions_SAdmissions__uiCRE","SDetailHeader":"ChartItemAdmissions_SDetailHeader__xgwoF"};